export var officeTaosHubTelemetryConfig = {
    appName: 'OfficeTaosHub',
    diagnosticTelemetryNamespace: 'Office.Taos.Hub.Diagnostic',
    diagnosticOTelAriaTenant: '6dd53ce2cf7c4e9ca43c3702bdbf521a-0877f49d-9760-44f7-839a-5ece6d961731-6816',
    oTelAriaTenant: 'eba120086311400a9b62c4718c0934d3-7ec73bd2-d8e8-450d-84d0-7f0a2ade31ce-7166',
    telemetryNamespace: 'Office.Taos.Hub',
};
//# sourceMappingURL=officeTaosHubTelemetryConfig.js.map